import { FrameworkConfiguration } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-framework'; 


export function configure(aurelia: FrameworkConfiguration) {
    aurelia.globalResources([
        PLATFORM.moduleName("./address-value-converter"),
        PLATFORM.moduleName("./label-case-value-converter"),
    ]);
}
